import Heading from '@/common/shared/heading'
import { Separator } from '@/common/ui/separator'
import CreatePaymentGatewayForm from '../CreatePaymentGatewayForm'
import { useParams } from 'react-router-dom'
import EditPaymentGatewayForm from '../../../EditPaymentGateway/components/EditPaymentGatewayForm'
import NavigateBackButton from '@/common/components/NavigateBackButton'

export default function PaymentGatewayListing() {
	const { id } = useParams()

	return (
		<div className="space-y-4">
			<div className="flex items-start justify-between">
				<Heading
					title={`${id ? 'แก้ไข' : 'สร้าง'}บัญชีธนาคารออโต้`}
					description="สร้างบัญชีธนาคารออโต้"
				/>
				<NavigateBackButton />
			</div>
			<Separator />
			{id ? <EditPaymentGatewayForm /> : <CreatePaymentGatewayForm />}
		</div>
	)
}
